import { TIER_META, TIER_KEYS } from "@/constants";

/**
 * GemLegend — Explicación pública de los metales/niveles ligados al tier.
 * Se usa en el Dashboard y en la página del proveedor.
 *
 * Uso:  <GemLegend />
 */
export function GemLegend() {
  return (
    <section className="my-6" data-testid="gem-legend">
      <div className="mb-3">
        <div className="text-[10px] uppercase tracking-widest text-[var(--lala-blue)] font-bold">Distintivo visual · sello LinkedIn-able</div>
        <h3 className="font-display text-xl text-[var(--ink)]">Metales Lala Elite</h3>
        <p className="text-xs text-[var(--ink-soft)] max-w-2xl">
          Cada nivel del programa lleva un metal asociado — de Bronce a Platino. Es el sello visual que el proveedor pega en su firma de correo, LinkedIn o sitio web.
        </p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-3">
        {["recuperacion"].concat(TIER_KEYS).map((k) => {
          const t = TIER_META[k];
          if (!t) return null;
          return (
            <div
              key={k}
              className="bg-white rounded-xl border p-4 flex flex-col items-center text-center"
              style={{ borderColor: t.gemColor }}
              data-testid={`gem-card-${k}`}
            >
              <img
                src={`/brand/icon_gem_${k}.png`}
                alt=""
                className="w-12 h-12 mb-2 object-contain"
                data-testid={`gem-icon-${k}`}
                draggable={false}
              />
              <div className="text-[9px] uppercase tracking-wider text-[var(--ink-soft)] font-bold">{t.label}</div>
              <div className="font-display text-base leading-none mt-0.5" style={{ color: t.gemColor }}>{t.gem}</div>
              <div className="text-[10px] text-[var(--ink-soft)] mt-1.5 leading-tight">{t.range}</div>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default GemLegend;
